import Model, { attr, type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { MarketPerformanceDataItem } from 'lumen/models';

export default class MarketPerformanceSubscription extends Model {
  [Type] = 'market-performance/subscription' as const;

  @hasMany('market-performance/data-item', {
    async: false,
    inverse: 'subscription',
  })
  declare dataItems: HasMany<MarketPerformanceDataItem>;

  @attr('string') declare currencyCode: string;
  @attr('string') declare hotelName: string;
}
